export default "__VITE_IMAGE_ASSET__b838542a__";